var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VApp',{class:{'guest-page': _vm.isGuestPage},style:(_vm.styles)},[_c(_vm.layout,{tag:"Component"},[_c('ErrorBoundary',[_c('RouterView')],1)],1),_c('UNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }